<template>
  <v-container fluid>
    <v-tabs>
      <v-tab>
        {{ $t("lang.notification.history") }}
      </v-tab>
      <v-tab-item>
        <notification-dialog
          :card="clickedCard"
          :dialog="dialog"
          @cardMarkRead="updateNotificationList"
          @cardMarkCancel="dialog = false"
        ></notification-dialog>
        <gru-table
          :resource="'notification/activities'"
          :fields="fields"
          :enabledExcel="false"
          :enabledAdd="false"
          :enabledDelete="false"
          :primaryKey="'id'"
          :handleEdit="clickActivityHandle"
          :hiddenC="hiddenC"
          :pagination="pagination"
        ></gru-table>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import NotificationDialog from "./NotificationDialog";
export default {
  name: "NotificationActivity",
  components: { NotificationDialog },
  data() {
    return {
      clickedCard: {
        sender: {},
        receiver: {}
      },
      dialog: false,
      hiddenC: [
        {
          columnName: "receiver",
          columnType: "STRING",
          value: this.$store.state.auth.user.username
        }
      ],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        sortBy: "id",
        totalItems: 0,
        rowsPerPageItems: [10, 20],
        paging: true
      },

    };
  },
  computed: {
    cards() {
      return this.$store.getters.notificationList;
    },
    fields() {
      return [
        {
          text: "lang.notification.title",
          value: "title",
          sortable: true,
          editable: true
        },
        {
          text: "lang.notification.sender",
          value: "sender",
          sortable: true,
          editable: false
        },
        {
          text: "lang.notification.sendAt",
          value: "sent_at",
          sortable: true,
          editable: false,
          columnType: "DATE"
        },
        {
          text: "lang.notification.is_read",
          value: "is_read",
          columnType: "BOOLEAN",
          optionValues: [
            { text: "Read", value: 1 },
            { text: "Unread", value: 0 }
          ]
        }
      ]
    }

  },
  methods: {
    clickActivityHandle(id) {
      this.dialog = true;
      this.clickedCard = this.cards.find(function(element) {
        return element.id === id;
      });
    },
    updateNotificationList(card) {
      this.dialog = false;
      this.$store.dispatch("updateNotificationList", card);
    }
  },
  created() {
    //this.$store.dispatch("getNotificationList");
  }
};
</script>

<style scoped></style>
